import RequestCodeForm from '@features/games/profile/phone-number/request-code-form/request-code-form';
export default RequestCodeForm;
